import { render, staticRenderFns } from "./fictionList.vue?vue&type=template&id=84f35284&"
import script from "./fictionList.vue?vue&type=script&lang=js&"
export * from "./fictionList.vue?vue&type=script&lang=js&"
import style0 from "./fictionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports